import { render, staticRenderFns } from "./PostContent.vue?vue&type=template&id=45c6f600&scoped=true&lang=pug&"
import script from "./PostContent.vue?vue&type=script&lang=js&"
export * from "./PostContent.vue?vue&type=script&lang=js&"
import style0 from "./PostContent.vue?vue&type=style&index=0&id=45c6f600&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c6f600",
  null
  
)

export default component.exports